import { render, staticRenderFns } from "./MainScene.vue?vue&type=template&id=6cc28288&scoped=true"
import script from "./MainScene.vue?vue&type=script&lang=js"
export * from "./MainScene.vue?vue&type=script&lang=js"
import style0 from "./MainScene.vue?vue&type=style&index=0&id=6cc28288&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc28288",
  null
  
)

export default component.exports